/**
 * A loyalty tier's colour on a ground, derived by one rule.
 *
 * Tier colours are identity hues (lib/api.js LOYALTY_TIERS; the current tier's colour also arrives from the
 * server as badge_color). They were picked for the dark theme, and as TEXT several were unreadable: on paper
 * Standard #94A3B8 2.56:1 and Topaz #D4A574 2.23:1 (found on the admin Client Detail page), and Quartz, Amber and
 * Diamond, which had a hand-picked light table of their own; in dark, Sapphire #0F52BA is about 2.6:1.
 * Same rule as the status fills (lib/statusChart.js) and the chat's role colours (lib/roleInk.js): keep the hue,
 * step the lightness until it clears `floor` against the worst ground in that theme -- 4.5:1 for text (default),
 * 3:1 for a graphic such as the Gem Bag's stone. It works on any colour, so a server colour no table knows about
 * gets the same treatment.
 */
import { chartFill } from './statusChart.js';

export const TIER_TEXT_FLOOR = 4.5;
export const TIER_GROUNDS = { dark: ['#101010', '#171717', '#1e1e1e'], light: ['#f4f4f5', '#ffffff', '#ebebed'] };
const WORST = { dark: '#1e1e1e', light: '#ebebed' };

// `name` is kept for the call sites' signature; the colour alone decides.
export function tierInk(name, color, isLight, floor = TIER_TEXT_FLOOR) {
  if (!color || !/^#[0-9a-f]{6}$/i.test(color)) return color;
  return chartFill(color, WORST[isLight ? 'light' : 'dark'], floor);
}
